import { render, staticRenderFns } from "./StockSettings.vue?vue&type=template&id=286b1e9a&"
import script from "./StockSettings.vue?vue&type=script&lang=js&"
export * from "./StockSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports